//@ts-nocheck
import {
  Box,
  Flex,
  HStack,
  IconButton,
  Image,
  Stack,
  Text,
  useRadio,
  useRadioGroup,
  VStack,
} from "@chakra-ui/react";
import React, { FunctionComponent } from "react";
import { FaRegFlag } from "react-icons/fa";
import MarkdownParser from "./MarkdownParser";

export const options: { [key: number]: string } = {
  0: "A",
  1: "B",
  2: "C",
  3: "D",
  4: "E",
};

const AnswerOption = React.forwardRef<
  any,
  {
    showOptionsLabel: boolean;
    isDisabled: boolean;
    value: any;
    is_horizontal: boolean;
    isChecked: boolean;
    checkedColor?: string;
    id: any;
    figure?: string;
    katexContent: any;
    isCorrect?: boolean;
    [key: string]: any;
  }
>((props, ref) => {
  const {
    children,
    showOptionsLabel,
    isDisabled,
    value,
    is_horizontal,
    checkedColor = "green.600",
    isChecked,
    isCorrect,
    id,
    figure,
    katexContent,
    ...rest
  } = props;
  const { getInputProps, getCheckboxProps } = useRadio(props);
  const inputProps: any = getInputProps();
  const checkboxProps: any = getCheckboxProps();
  const beforeStyles = (isChecked) => {
    return {
      content: '""',
      opacity: 1,
      height: "28px",
      width: "28px",
      borderRadius: "0 0 0 4px",
      padding: 3,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: isChecked
        ? checkedColor
        : // : isCorrect
          //   ? "red.600"
          "neutral.500",
      position: "absolute" as any,
      right: "-3px",
      top: 0,
      visibility: "visible",
      zIndex: 1,
    };
  };

  const afterStyles = (isChecked) => {
    return {
      content: '""',
      opacity: "1 !important",
      display: "flex",
      border: "2px solid #ffffff",
      backgroundColor: isChecked
        ? checkedColor
        : // : isCorrect
          //   ? "red.600"
          "neutral.500",
      height: "16px",
      width: "16px",
      borderRadius: "100px",
      position: "absolute",
      right: "1px",
      top: "5px",
      visibility: "visible",
      alignSelf: "center",
      margin: "0 auto",
      zIndex: 1,
    };
  };

  return (
    <Box as="label" d="contents">
      <input {...inputProps} />
      <Box
        {...checkboxProps}
        role="radio"
        py={6}
        px={3}
        ref={ref}
        aria-checked={isChecked}
        borderWidth="sm"
        borderColor={
          isChecked
            ? checkedColor
            : // : isCorrect ? "red.600"
              "neutral.500"
        }
        rounded="lg"
        bg="neutral.50"
        display="flex"
        alignItems="center"
        justifyContent={["flex", is_horizontal ? "center" : "flex"]}
        width={["100%", is_horizontal ? "25%" : "100%"]}
        mb={[2, is_horizontal ? 0 : 2]}
        mr={[2, is_horizontal ? 2 : 0]}
        minHeight={["84px", is_horizontal ? "160px" : "96px"]}
        height={["auto", is_horizontal ? "160px" : "96px"]}
        position="relative"
        _hover={{ cursor: "pointer" }}
        _focus={{ outline: "none" }}
        {...rest}
      >
        <Box
          className="Answer Option"
          as="span"
          mr={[6, is_horizontal ? 0 : 6]}
          ml={[4, is_horizontal ? 0 : 4]}
          bg="white"
          rounded="sm"
          padding="1px 6px"
          borderWidth="2xs"
          textAlign="center"
          position={["relative", is_horizontal ? "absolute" : "relative"]}
          left={["auto", is_horizontal ? "5px" : "auto"]}
          bottom={["auto", is_horizontal ? "5px" : "auto"]}
        >
          {showOptionsLabel ? value : ""}
        </Box>
        {/* <Box
          {...{ position: "absolute", right: "2px", top: "-1px" }}
          _before={beforeStyles(isChecked)}
          _after={afterStyles(isChecked)}
        /> */}
        {figure ? (
          <Image src={figure} objectFit="contain" alt="option-image" />
        ) : (
          <QuestionComponent question={katexContent} />
        )}
      </Box>
    </Box>
  );
});

const TrueOrFalseOptions = ["true", "false", "null"];

const TrueOrFalseOptionsValue: { [key: string]: any } = {
  true: "true",
  false: "false",
  null: "null",
};

export const QuestionOptions: FunctionComponent<{
  question_type: string;
  answers: any[];
  is_horizontal: boolean;
  handleClick: (...args: any[]) => void;
  isSelected: any;
  variant?: string;
  isTrueOrFalseOptions?: boolean;
  isMultipleChoice?: boolean;
  isCorrect?: (val: any) => boolean;
  [key: string]: any;
}> = ({
  question_type,
  answers = [],
  is_horizontal = false,
  handleClick,
  isSelected,
  isTrueOrFalseOptions = false,
  isMultipleChoice = false,
  isCorrect,
  ...rest
}) => {
  // const isTrueOrFalseOptions = answers.length <= 3;
  const { getRootProps, getRadioProps } = useRadioGroup({
    onChange: (val) => {
      if (isTrueOrFalseOptions) {
        handleClick(TrueOrFalseOptionsValue[val]);
      } else {
        handleClick(val);
      }
    },
    defaultValue: isSelected,
  });

  const rootProps: any = getRootProps();

  return (
    <Flex
      className="Question Options"
      {...rootProps}
      flexDirection={["column", is_horizontal ? "row" : "column"]}
    >
      {answers.map((answer, index) => {
        const value =
          answer.option ||
          (isTrueOrFalseOptions
            ? TrueOrFalseOptions[index]
            : isMultipleChoice
              ? options[answers.indexOf(answer)]
              : options[index]);

        const radioProps = getRadioProps({ value } as any);
        return (
          <AnswerOption
            {...radioProps}
            checkedColor={
              isCorrect
                ? isCorrect(value)
                  ? "green.500"
                  : "red.500"
                : "green.500"
            }
            showOptionsLabel={!isTrueOrFalseOptions}
            key={`cio-${index}`}
            is_horizontal={is_horizontal}
            id={`choice${value}`}
            value={value}
            figure={answer.figure}
            isCorrect={isCorrect ? isCorrect(value) : false}
            katexContent={answer.content}
          />
        );
      })}
    </Flex>
  );
};

const QuestionComponent: FunctionComponent<{
  question: any;
}> = ({ question }) => {
  return <MarkdownParser text={question} />;
};

const QuestionStyle: FunctionComponent<{
  question_type: string;
  question: any;
  questionNo?: number;
  answers?: any[];
  displayAnswer?: boolean;
  is_horizontal: boolean;
  onAnswerClick: (...args: any[]) => void;
  onFlagClick?: () => void;
  lastQuestion?: number;
  isSelected?: any;
  image?: any;
  direction: string;
  variant?: string;
  questionTitle?: string;
  isTrueOrFalseOptions?: boolean;
  isMultipleChoice?: boolean;
  displayQuestionNo?: boolean;
  displayOptions?: boolean;
  isCorrect?: (val: any) => boolean;
  headerVariant?: { color: string };
}> = ({
  question_type,
  question,
  questionNo,
  answers,
  displayAnswer,
  is_horizontal = false,
  onAnswerClick,
  lastQuestion,
  questionTitle,
  isSelected,
  onFlagClick,
  image,
  direction,
  displayQuestionNo = true,
  displayOptions = true,
  isCorrect,
  isTrueOrFalseOptions,
  isMultipleChoice,
  headerVariant = { color: "black" },
}) => {
  function isAudio(url = "") {
    return url.slice(url.length - 4).toLowerCase() === ".mp3";
  }
  function isVideo(_url = "") {
    let url = _url || "";
    const extensions = [".mp4"];
    return extensions.includes(url.slice(url.length - 4).toLowerCase());
  }
  const imageDisplay =
    image && isAudio(image || '') ? (
      <Box
        display="flex"
        justifyContent="center"
        my="40px"
        className="question-image"
      >
        <figure>
          <figcaption style={{ textAlign: "center", marginBottom: "10px" }}>
            Listen to the audio:
          </figcaption>
          <audio controls src={image}>
            Your browser does not support the
            <code>audio</code> element.
          </audio>
        </figure>
      </Box>
    ) : isVideo(image || '') ? (
      <Box
        display="flex"
        justifyContent="center"
        my="40px"
        className="question-image"
      >
        <figure>
          <figcaption style={{ textAlign: "center", marginBottom: "10px" }}>
            Watch the video:
          </figcaption>
          <video controls>
            <source src={image} type="video/mp4" />
            <source src={image} type="video/ogg" />
            Your browser does not support the
            <code>video</code> element.
          </video>
        </figure>
      </Box>
    ) : image ? (
      <Box flex={1} h={["auto", "240px"]} className="question-image">
        <Image
          h="100%"
          w="100%"
          objectFit="contain"
          alt="question-image"
          src={image}
        />
      </Box>
    ) : null;

  return (
    <Flex flexDirection="column" className="choice-section">
      <Box flex={1}>
        <Stack mb={[6, 8]}>
          <HStack justify="space-between">
            {displayQuestionNo && (
              <Text
                {...headerVariant}
                mt={4}
                mr={2}
                fontWeight="bold"
                className="Question Number"
              >
                {lastQuestion
                  ? `Question ${questionNo} of ${lastQuestion}`
                  : `Question ${questionNo}`}
              </Text>
            )}

            {onFlagClick ? (
              <IconButton
                variant="ghost"
                onClick={onFlagClick}
                aria-label="flag button"
                icon={<FaRegFlag />}
              />
            ) : null}
          </HStack>
          <Stack
            w="100%"
            pt={!displayQuestionNo && questionTitle ? [4, 5] : 0}
            mb={[6, 8]}
            // direction={["column-reverse", "row"]}
            className="Question Text"
          >
            <QuestionComponent question={question} />
            {direction === "column" && imageDisplay}
            {displayAnswer ? (
              <Text fontWeight="medium" color="red.500">
                You selected the wrong answer.
              </Text>
            ) : null}
          </Stack>
        </Stack>

        {displayOptions && (
          <QuestionOptions
            question_type={question_type}
            is_horizontal={is_horizontal}
            answers={answers}
            isCorrect={isCorrect}
            handleClick={onAnswerClick}
            isSelected={isSelected}
            isMultipleChoice={isMultipleChoice}
            isTrueOrFalseOptions={isTrueOrFalseOptions}
            display="flex"
            flex={1}
          />
        )}
      </Box>
      {direction === "row" && imageDisplay}
    </Flex>
  );
};

export default QuestionStyle;

// import {
//   Box,
//   Flex,
//   Image,
//   RadioGroup,
//   Stack,
//   Text,
//   useRadio,
//   useRadioGroup,
// } from "@chakra-ui/react";
// import MarkdownParser from "./MarkdownParser";
// import React, { Suspense } from "react";

// export const options = {
//   0: "A",
//   1: "B",
//   2: "C",
//   3: "D",
//   4: "E",
// };

// const QuestionComponent = ({ question }) => {
//   return <MarkdownParser text={question} />;
// };

// const answerWrapper = (isChecked, is_horizontal, ref) => {
//   // console.log({ answerWrapper: is_horizontal });
//   return {
// role: "radio",
// py: 6,
// px: 3,
// ref: ref,
// "aria-checked": isChecked,
// borderWidth: "sm",
// borderColor: isChecked ? "green.600" : "neutral.500",
// rounded: "lg",
// bg: "neutral.50",
// alignItems: "center",
// justifyContent: ["flex-start", is_horizontal ? "center" : "flex"],
// width: ["100%", is_horizontal ? "25%" : "100%"],
// mb: [2, is_horizontal ? 0 : 2],
// mr: [0, is_horizontal ? 2 : 0],
// height: ["75px", is_horizontal ? "160px" : "inherit"],
// position: "relative" as any,
// _hover: { cursor: "pointer" },
// _focus: { outline: "none" },
//   };
// };

// const optionLabel = (is_horizontal) => {
//   // console.log({ optionLabel: is_horizontal });
//   return {
// as: "span" as any,
// mr: [6, is_horizontal ? 0 : 6],
// ml: [4, is_horizontal ? 0 : 4],
// bg: "white",
// rounded: "sm",
// padding: "1px 6px",
// borderWidth: "2xs",
// textAlign: "center" as any,
// position: ["relative", is_horizontal ? "absolute" : "relative"] as any,
// left: ["auto", is_horizontal ? "5px" : "auto"],
// bottom: ["auto", is_horizontal ? "5px" : "auto"],
//   };
// };

// const beforeStyles = (isChecked) => {
//   return {
//     content: '""',
//     opacity: 1,
//     height: "28px",
//     width: "28px",
//     borderRadius: "0 0 0 4px",
//     padding: 3,
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     backgroundColor: isChecked ? "green.600" : "neutral.500",
//     position: "absolute" as any,
//     right: "-3px",
//     top: 0,
//     visibility: "visible",
//     zIndex: 1,
//   };
// };

// const afterStyles = (isChecked) => {
//   return {
//     content: '""',
//     opacity: "1 !important",
//     display: "flex",
//     border: "2px solid #ffffff",
//     backgroundColor: isChecked ? "green.600" : "neutral.500",
//     height: "16px",
//     width: "16px",
//     borderRadius: "100px",
//     position: "absolute",
//     right: "1px",
//     top: "5px",
//     visibility: "visible",
//     alignSelf: "center",
//     margin: "0 auto",
//     zIndex: 1,
//   };
// };

// const ChoiceWrap = ({ children, ...props }) => {
//   return (
//     <Box
//       w="100%"
//       mb={[6, 8]}
//       position={["relative", props.is_horizontal ? null : "relative"]}
//     >
//       {children}
//     </Box>
//   );
// };

// // const RegularMarkdown = ({ text, render }) => {
// //   return <div dangerouslySetInnerHTML={{ __html: text || "" }} />;
// // };
// // export const KatexContext = React.createContext({
// //   LoadKatext: RegularMarkdown,
// //   // LoadKatext: Div
// // });

// type AnswerOptionsType = {
//   isDisabled: boolean;
//   value: any;
//   is_horizontal: boolean;
//   isChecked: boolean;
//   id: any;
//   katexContent: any;
//   is_latex: boolean;
//   [key: string]: any;
// };

// const AnswerOption = React.forwardRef((props: AnswerOptionsType, ref) => {
//   const {
//     isDisabled,
//     value,
//     is_horizontal,
//     isChecked,
//     id,
//     katexContent,
//     question,
//     is_latex,
//     ...rest
//   } = props;
//   const { getInputProps, getCheckboxProps } = useRadio(props);
//   const inputProps = getInputProps();
//   const checkboxProps = getCheckboxProps();
//   console.log({ props });

//   return (
// <Box as="label" d="contents">
//   <input {...inputProps} />
//   <Box
//     className="Answer Wrapper"
//     {...checkboxProps}
//     {...answerWrapper(isChecked, is_horizontal, ref)}
//     {...rest}
//   >
//     <Box className="Answer Option" {...optionLabel(is_horizontal)}>
//       {value}
//     </Box>
//     <Box
//       {...{ position: "absolute", right: "2px", top: "-1px" }}
//       _before={beforeStyles(isChecked)}
//       _after={afterStyles(isChecked)}
//     />
//     <QuestionComponent question={katexContent} />
//   </Box>
// </Box>
//   );
// });

// const QuestionOptions: React.FC<{
//   answers: Array<any>;
//   is_horizontal: boolean;
//   handleClick: (...params) => void;
//   isSelected: boolean;
//   isTrueOrFalseOptions?: boolean;
//   answerOptionStyle?: any;
//   isMultipleChoice?: boolean;
//   [key: string]: any;
// }> = ({
//   answers = [],
//   is_horizontal = false,
//   handleClick,
//   isSelected,
//   isTrueOrFalseOptions = false,
//   answerOptionStyle,
//   isMultipleChoice,
//   ...rest
// }) => {
//   const TrueOrFalseOptions = ["true", "false", "null"];

//   const TrueOrFalseOptionsValue: { [key: string]: any } = {
//     true: "true",
//     false: "false",
//     null: "null",
//   };

//   const { getRootProps, getRadioProps } = useRadioGroup({
//     onChange: (val) => {
//       if (isTrueOrFalseOptions) {
//         handleClick(TrueOrFalseOptionsValue[val]);
//       } else {
//         handleClick(val);
//       }
//     },
//     defaultValue: isSelected,
//   });

//   const rootProps = getRootProps();

//   return (
//     <Flex className="Question Options" {...rootProps} {...rest}>
//       {answers.map((answer, index) => {
//         const value =
//           answer.option ||
//           (isTrueOrFalseOptions
//             ? TrueOrFalseOptions[index]
//             : isMultipleChoice
//             ? options[answers.indexOf(answer)]
//             : options[index]);

//         const radioProps = getRadioProps({ value } as any);
//         return (
//           <AnswerOption
//             {...radioProps}
//             showOptionsLabel={!isTrueOrFalseOptions}
//             key={`cio-${index}`}
//             is_horizontal={is_horizontal}
//             id={`choice${value}`}
//             value={value}
//             katexContent={answer.content}
//             styles={answerOptionStyle}
//           />
//         );
//       })}
//     </Flex>
//     // <Flex
//     //   className="Question Options"
//     //   flexDirection={is_horizontal ? "row" : "column"}
//     // >
//     //   <RadioGroup
//     //     value={isSelected}
//     //     onChange={(val) => handleClick(val)}
//     //     display="flex"
//     //     flex={1}
//     //     flexDirection={["column", is_horizontal ? "row" : "column"]}
//     //   >
//     //     {answers.map((answer, index) => (
//     //       <AnswerOption
//     //         key={`cio-${index}`}
//     //         is_horizontal={is_horizontal}
//     //         id={`choice${answer.option || options[index]}`}
//     //         value={answer.option || options[index]}
//     //         katexContent={answer.content}
//     //         is_latex={answer.is_latex}
//     //       />
//     //     ))}
//     //   </RadioGroup>
//     // </Flex>
//   );
// };

// const QuestionStyle = ({
//   question,
//   questionNo,
//   answers,
//   is_horizontal = false,
//   onAnswerClick,
//   lastQuestion,
//   is_latex,
//   isSelected,
//   image,
//   direction,
// }) => {
//   let imageDisplay = image && (
//     <Box flex={1} className="question-image" h={["auto", "240px"]}>
//       <Image
//         h="100%"
//         w="100%"
//         objectFit="contain"
//         alt="question-image"
//         src={image}
//       />
//     </Box>
//   );

//   return (
//     <Flex
//       w="100%"
//       direction={["column-reverse", "row"]}
//       className="choice-section"
//     >
//       <Box flex={1}>
//         <Stack>
//           <Text
//             mr={2}
//             fontWeight="bold"
//             className="Question Number"
//           >{`Question ${questionNo} of ${lastQuestion}`}</Text>
//           <Box flex={1} className="Question Text">
//             <ChoiceWrap is_horizontal={is_horizontal}>
//               <QuestionComponent question={question} />
//               {direction === "column" && imageDisplay}
//             </ChoiceWrap>
//           </Box>
//         </Stack>
//         <QuestionOptions
//           is_horizontal={is_horizontal}
//           answers={answers}
//           handleClick={onAnswerClick}
//           isSelected={isSelected}
//         />
//       </Box>
//       {direction === "row" && imageDisplay}
//     </Flex>
//   );
// };

// export default QuestionStyle;
